import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/home/index'
import studyAndStudy from '@/pages/system/studyAndStudy'
import examination from '@/pages/test/examination'
import search from '@/pages/search/search'
import resume from '@/pages/resume/resume'
import news from '@/pages/news/news'
import newsPopup from '@/pages/newsPopup/newsPopup'
import majorfunction from '@/pages/home/components/majorfunction'
import SelectChapter from '@/pages/study/components/SelectChapter'
import login from '../pages/home/components/login'

import study from '@/pages/study/study/'

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
    },
    {
      path: '/home',
      name: 'home',
      component: () => import("@/pages/homePage"),
      children:[
        {
          path: '/index',
          name: 'index',
          component: () => import("@/pages/home/index"),
          children: [
            {
              path: '',
              name: 'majorfunction',
              component: majorfunction,
            },
            {
              path: 'studyModule',
              name: 'studyModule',
              component: () => import("@/pages/system/studyModule")
            },
            {
              path: 'studyAndStudy',
              name: 'studyAndStudy',
              component: studyAndStudy
            },
          ]
        },
        {
          path: '/rule',
          name: 'rule',
          component: () => import("@/pages/rule"),
        },
        {
          path: '/classificationInfo',
          name: 'classificationInfo',
          component: () => import("@/pages/classification"),
        },
        {
          path: '/examination',
          name: 'examination',
          component: examination,
        },
        {
          path: '/search',
          name: 'search',
          component: search,
        },
        {
        path: '/resume',
        name: 'resume',
        component: resume,
        },
        {
          path: '/news',
          name: 'news',
          component: news,
        },
        {
          path: '/personNews',
          name: 'personNews',
          component: () => import("@/pages/personNews")
        },
        {
          path: '/studyModel',
          name: 'studyModel',
          component: () => import("@/pages/studyModel"),
        },
        {
          path: '/newsPopup',
          name: 'newsPopup',
          component: newsPopup,
        },
        {
          path: '/study',
          name: 'study',
          component: study,
        },
        {
          path: '/SelectChapter',
          name: 'SelectChapter',
          component: SelectChapter,
        },
      ]
    },
    {
      path: '/course',
      name: 'course',
      component: () => import("@/pages/course")
    },
  ]
})
export default router
// 路由守卫
router.beforeEach((to, form, next) => {
  let user = localStorage.getItem("userInfo");
  if(user != null && to.name === 'login'){
    console.info("跳转到首页")
    router.push({name:'index'});
  } else {
    next();
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js